/* Client-side store for the registered client (used after PWA install) */

const PROFILE_KEY = "gs_client_profile";
const TOKEN_KEY = "gs_client_token";

export function getClientProfile() {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveClientProfile(profile) {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
}

export function clearClientProfile() {
  localStorage.removeItem(PROFILE_KEY);
  localStorage.removeItem(TOKEN_KEY);
}

export function getClientToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function saveClientToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}
